// routes
import React from 'react';
import Router from "./routes";
// theme


// components

import { Theme } from "./theme/ThemeContext";
import { ChatProvider } from "./contexts/ChatContext";
import { RemoveChatProvider } from './contexts/RemoveChatContext';
import { ParallaxProvider } from 'react-scroll-parallax';
function App() {
  return (
    <>
    
          <ChatProvider>
          <RemoveChatProvider>
            
          <Theme>
            <ParallaxProvider>
            <Router />
            </ParallaxProvider>
          </Theme>
          </RemoveChatProvider>
           {/*  <ParticlesComponent id="particle"/> */}
          </ChatProvider>
          
          
         
    </>
  );
}

export default App;
